module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.5244/images/default-avatar.png"